import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Tweets from '@/components/Tweets'
import Articles from '@/components/Articles'
import Sources from '@/components/Sources'
import Hashtags from '@/components/Hashtags'
import Users from '@/components/Users'
import Stories from '@/components/Stories'
import Sentiment from '@/components/Sentiment'
import Entities from '@/components/Entities'
import Backtracker from '@/components/Backtracker'
import LiveView from '@/components/LiveView'
import Report from '@/components/Report'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      component: Home
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/tweets',
      component: Tweets
    },
    {
      path: '/articles',
      component: Articles
    },
    {
      path: '/sources',
      component: Sources,
      props: true
    },
    {
      path: '/stories',
      component: Stories,
      props: true
    },
    {
      path: '/sentiment',
      component: Sentiment,
      props: true
    },
    {
      path: '/entities',
      component: Entities,
      props: true
    },
    {
      path: '/backtracker',
      component: Backtracker,
      props: true
    },
    {
      path: '/hashtags',
      component: Hashtags
    },
    {
      path: '/users',
      component: Users
    },
    {
      path: '/live',
      component: LiveView
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/report',
      component: Report
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.path !== from.path) {
      return { x: 0, y: 0 }
    } else {
      return savedPosition
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js